import { UpdateUserSettingsReducer } from './crud';

export const reducers = [UpdateUserSettingsReducer];
